import { render, staticRenderFns } from "./ReceivedLogs.vue?vue&type=template&id=32769ee6&"
import script from "./ReceivedLogs.vue?vue&type=script&lang=js&"
export * from "./ReceivedLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports